import { useUser } from '@cobliteam/hooks';
import { useTranslation } from '@cobliteam/i18n';
import { lazy } from '@cobliteam/lazy-with-retries';
import Dialog from '@cobliteam/ui/components/Dialog';
import TooltipOnIntent from '@cobliteam/ui-business/components/TooltipOnIntent/TooltipOnIntent';
import { Suspense } from 'react';

// Typeform (~58 KB) só é baixado quando o dialog abre: o conteúdo do Dialog não monta fechado.
const FeedbackTypeformWidget = lazy(() => import('./FeedbackTypeformWidget'));

interface FeedbackProps {
  showTooltip?: boolean;
  source?: string;
  children?: React.ReactNode;
}

const Feedback = ({ source = 'navbar', showTooltip = true, children }: FeedbackProps) => {
  const { t } = useTranslation('app-header');
  const { user, session, hasNoValidGroups } = useUser();

  if (hasNoValidGroups) return null;

  return (
    <Dialog>
      <Dialog.Trigger asChild>
        <div>
          <TooltipOnIntent render={<div>{children}</div>} disabled={!showTooltip}>
            {t('feedback.button')}
          </TooltipOnIntent>
        </div>
      </Dialog.Trigger>
      <Dialog.Content size='lg'>
        <Dialog.Header>
          <Dialog.Title>{t('feedback.title')}</Dialog.Title>
          <Dialog.Description className='sr-only' />
          <Dialog.Close />
        </Dialog.Header>
        <Dialog.Body>
          <Suspense fallback={<div className='h-[600px]' />}>
            <FeedbackTypeformWidget
              hidden={{
                email: user?.email || '',
                user_id: user?.id || '',
                name: user?.name || '',
                url: window.location.href || '',
                source,
                fleet_id: session?.fleet.id || '',
                fleet_name: session?.fleet.name || '',
              }}
            />
          </Suspense>
        </Dialog.Body>
      </Dialog.Content>
    </Dialog>
  );
};

export default Feedback;
